<template>
    <layout-base>
      <div class="dashboard">
        <router-view></router-view>
      </div>
    </layout-base>
</template>

<script>
import LayoutBase from '../layout/LayoutBase'
export default {
  name: 'Dashboard',
  components: {
    LayoutBase
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  min-height: calc(100vh - 60px);
  background-color: white;
  padding: 40px;
}
@media screen and (max-width: 600px){
  .dashboard {
    padding: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/Dashboard.vue